import axiosinstance from '../axios/axiosInstance';
import React, { createContext, useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie'
import { AuthContext } from './AuthContext';
import { useRef } from 'react';

export const PlayerProfileContext = createContext();

export const PlayerProfileProvider = ({ children }) => {
    const [playerProfileData, setPlayerProfileData] = useState({});
    const [playerReferredFriends, setPlayerReferredFriends] = useState();
    const { isAuthenticated } = useContext(AuthContext);

    // useEffect(() => {
    //     const value = { user_id: Cookies.get('user_id') };
    //     const fetchData = async () => {
    //         await axiosinstance.post("/user/profile", value, {
    //             headers: {
    //                 'Authorization': Cookies.get('uid')
    //             }
    //         }).then((res) => {
    //             if (res.status === 201 ||res.status === 200 ) {
    //                 setPlayerProfileData(res.data.profile);
    //                 setPlayerReferredFriends(res?.data?.referred_users);
    //             }
    //             else {
    //                 console.log("Error while fetching the response ");
    //             }
    //         }).catch((err) => {
    //             console.log(err);
    //         });
    //     }
    //     fetchData();
    // }, [isAuthenticated])

    const fetchProfileData = async () => {
        if (!isAuthenticated) return;
        
        const value = { user_id: Cookies.get('user_id') };
        try {
            const res = await axiosinstance.post("/user/profile", value, {
                headers: {
                    'Authorization': Cookies.get('uid')
                }
            });

            if (res.status === 200 || res.status === 201) {
                setPlayerProfileData({
                    ...res.data.profile,
                    friend_count: res.data.friend_count
                });
                setPlayerReferredFriends(res.data.referred_users);
            } else {
                console.log("Error while fetching the response ");
            }
        } catch (err) {
            console.log(err);
        }
    };

    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;  // skip first render
            return;
        }

        if (isAuthenticated) {
            fetchProfileData();
        }
    }, [isAuthenticated]);

    // Initial fetch when component mounts and user is authenticated
    useEffect(() => {
        if (isAuthenticated) {
            fetchProfileData();
        }
    }, []);

    return (<PlayerProfileContext.Provider value={{ setPlayerProfileData, playerProfileData, playerReferredFriends, fetchProfileData }}>
        {children}
    </PlayerProfileContext.Provider>)
}
